const createAlertsStore = (set) => ({
  popupVisible: false,
  panelVisible: false,
  currentAlert: null,
  unreadCount: 0,

  setPopupVisible: (popupVisible) =>
    set((state) => ({
      alerts: {
        ...state.alerts,
        popupVisible,
      },
    })),

  setPanelVisible: (panelVisible) =>
    set((state) => ({
      alerts: {
        ...state.alerts,
        panelVisible,
      },
    })),

  setCurrentAlert: (currentAlert) =>
    set((state) => ({
      alerts: {
        ...state.alerts,
        currentAlert,
      },
    })),

  setUnreadCount: (unreadCount) =>
    set((state) => ({
      alerts: {
        ...state.alerts,
        unreadCount,
      },
    })),

  reset: () =>
    set(() => ({
      alerts: {
        popupVisible: false,
        panelVisible: false,
        currentAlert: null,
        unreadCount: 0,
      },
    })),
});

export default createAlertsStore;
